module.exports = __webpack_public_path__ + "img/mesa_l001h.afa1c459.png";